<template>
    <div class="bg-b" id="content-ofer">


        <div class="container">
            <el-row :gutter="100">


                <el-col :sm="24" :offset="0">

                    <div class="box-nivel">
                        <h3 class="pt-sans-bol">
                            <small>Subdirección Formación Docente Continua e Investigación</small>
                           CAPACITACIONES NIVEL {{ $route.params.nivel }}

                        </h3>

                    </div>


                </el-col>

            </el-row>
            <div v-if="capas.length">



                <div class="container">
                    <div class="card-grid">
                        <capaCard v-for="(card, index) in capas" :key="index" :card="card" />
                    </div>



                </div>

            </div>

        </div>
    </div>
</template>

<script>
import { HTTP } from "@/axios"

import capaCard from '@/components/capa.vue'
var VueScrollTo = require('vue-scrollto');
var options = {
    container: '#content-ofer',
    easing: 'ease-in',
    lazy: true,
    offset: -60,
    force: true,
    cancelable: true,
    onStart: function (element) {
        // scrolling started
    },
    onDone: function (element) {
        // scrolling is done
    },
    onCancel: function () {
        // scrolling has been interrupted
    },
    x: false,
    y: true
}

    export default {
    components: {  capaCard },
        data() {
        return {
            capas: [],
            textos: [],
            currentDate: new Date()
        }
    },
    created() {
        this.getCapas();
        this.getTextos();
    },

    methods: {
        getTextos()
        {
            HTTP.get('/textos/home')
                .then(res => {
                    this.textos = res.data
                    window.sessionStorage.setItem('textosSession', JSON.stringify(res.data))
                })
                .catch((e) => {

                    if (e.response.status === 429) {
                     
                        this.textos = JSON.parse(window.sessionStorage.getItem('textosSession'))
                        // return false
                    }

                })
        },
        getCapas()
        {
            
            HTTP.get('/capa/listado?nivel='+this.$route.params.nivel)
                .then(res => {
                    this.capas = res.data
                    window.sessionStorage.setItem('capaSession', JSON.stringify(res.data))
                })
                .catch((e) => {
                  
                    if (e.response.status === 429) {
                        this.$message({
                            message: 'Precaución, demasiadas peticiones en poco tiempo sobrecargan el servidor',
                            type: 'info',
                            showClose: false,
                            duration: 3000,
                        });

                        this.capa = JSON.parse(window.sessionStorage.getItem('capaSession'))
                        // return false
                    }
                    
                })
        },

        irCapas() {
            VueScrollTo.scrollTo('#capas', 300, options)
        },
        verCapa(id) {
            this.$router.push({ name: 'prueba', params: { id } })
        }
    },
    }
</script>
<style >
.box-nivel {
    margin-top: 10px;
    color: #FFF;

    font-family: 'Roboto', sans-serif;
    background: #08A6D6 url(@/assets/base4.png) !important;
    padding: 30px 30px;
    border-radius: 12px;
    text-align: center;
    text-transform: uppercase;
}

.box-nivel h3 {
    font-size: 32px;
 
}

.box-nivel small {
    font-size: 18px;
    display: block;
    margin-top: 10px;
    
}

.box-nivel p {
    text-align: left;
    font-size: 18px;
    padding: 20px;
}
</style>
<style lang="scss" scoped>
.box2{
    margin-top: 20px;
background: rgba(0, 0, 0, 0.05);
    padding:20px 10px;
    border-radius: 12px;
}

.sub-h1{
    color:white;
    font-size: 26px;
   
    text-align: center;
    text-transform: uppercase;
   
}
.sub-h1::before {
    background-image: linear-gradient(to right, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);
}
.login{
    padding:30px
}
.msg{
    text-align: center;
    font-size: 13px;
    bottom: 10px;
    position: absolute;
    color: red;
    left: 20px;
    // border:1px dashed #ddd;
    // padding:10px;
    // width: 50%;
    // background: #f1f1f1;
}
.fold h1{
    color: #333;
    font-size: 32px;
    line-height: 1; margin: 0;
    text-align: center;
    margin: 0px;
    margin-top: 10%;
    // font-weight: normal;
  
}
.fold h1  > small{
    font-size: 18px;
    display: block;
 font-weight: normal;
    padding: 20px;
    color: #636060;
}
.box img {
    position: absolute;
    height: 60px;
    bottom:10px;
    left:auto;
    right:10px;
}
.box {
    position: relative;
    margin: 80px auto;
    width: 100%;
    height: 350px;
    background: rgba(255,255,255,1);
    border-radius: 0px;
    // padding: 20px;
    border-left: 8px solid #174263;
    border-top-right-radius:0%;
}
.fold {

    padding: 50px;
    // position: absolute;
   

}

/*
  paper fold corner
*/

.box:before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    border-style: solid;
    border-width: 0 30px 30px 0;
    border-color: #ddd #174263;
    transition: all ease .5s;
}

/*
  on li hover make paper fold larger
*/
.box:hover:before {
    border-width: 0 35px 35px 0;
    border-color: #eee #174263;
}



@keyframes background {
    0% {
        background-position: 0% 50%;
    }

    50% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0% 50%;
    }
}

</style>
<style>
.card-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 16px;
    padding: 16px;
}

.listado {
    margin-top: 0px;
    height: calc(100vh - 200px);
    overflow: overlay;
    scrollbar-gutter: auto;
    overflow-x: hidden;

    /* Oculta las flechas del scroll */

}
</style>